import { Colors, Styleguide, theme } from "../../../theme";
import styled from "styled-components";

export const ContainerTerms = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  max-width: 312px;
  margin: 0px auto;
  align-items: center;

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    margin: 0 auto 4rem;
    max-width: 496px;
    width: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  @media screen and (min-width: 640px) {
    flex-grow: 0;
  }
`;

export const TermsText = styled.span`
  font-family: opensans-regular;
  font-size: 16px;
  letter-spacing: -0.1px;
  color: ${theme(Colors.gray[500], Colors.gray[100])};
  text-align: left;
  margin-bottom: 20px;
`;

export const TitleText = styled.h1`
  font-family: ${Styleguide.fonts.heading.name};
  font-weight: ${Styleguide.fontWeights.bold};
  font-size: ${Styleguide.fontSizes[24]};
  color: ${theme(Colors.gray[500], Colors.white)};
  text-align: left;
  margin: 24px 0 24px;
`;

export const ContainerCheckBox = styled.div`
  margin: 20px 0 0 0;
`;

export const LinkTerms = styled.a`
  font-family: opensans-bold;
  cursor: pointer;
  color: ${theme(Colors.gray[500], Colors.lightBlue[100])};
  text-decoration: underline;
`;

export const Button = styled.button`
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-family: "Globotipo UI";
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  justify-content: center;
  text-decoration: none;
  max-width: 360px;
  width: 100%;
  height: 40px;
  padding: 9px 0px;
  color: ${theme(Colors.white, Colors.gray[500])};
  background-color: ${theme(Colors.blue[100], Colors.white)};
  transition: opacity 0.3s;
  margin-top: 40px;

  &:hover {
    background: ${theme(Colors.blue[200], Colors.gray[200])};
  }

  &:focus {
    outline-width: 2px;
    outline-style: solid;
    outline-offset: 4px;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
    background: ${theme(Colors.blue[200], Colors.gray[200])};
  }

  :disabled {
    opacity: 0.8;
    cursor: auto;
  }

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 496px;
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0 24px 0px;
  flex-grow: 1;
  @media screen and (min-width: 640px) {
    flex-grow: 0;
  }
`;
